export default __webpack_public_path__ + "static/media/FlorenceToMilan.4121ac09.webp";